import axios from "../../lib/axios";

export async function postBuyGiftCard(params) {
  try {
    const res = await axios.post("/gift_cards/buy", params);
    return res.data.data;
  } catch (err) {
    throw err.response.data.data;
  }
}

export async function putActivateGiftCard(code) {
  try {
    const res = await axios.put(`/gift_cards/activate/${code}`);
    return res.data;
  } catch (err) {
    throw err.response;
  }
}